import { useSecondarySidebarStore } from '@/common/stores/secondarySidebarStore';
import { Button, Stack, Text, Tooltip } from '@mantine/core';
import { IconLayoutSidebar, IconPlus } from '@tabler/icons-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface WorkspaceAddButtonProps {
    onCreateWorkspace: () => void;
}

/**
 * 워크스페이스 생성 버튼 컴포넌트
 */
export const WorkspaceAddButton: React.FC<WorkspaceAddButtonProps> = ({
    onCreateWorkspace,
}) => {
    const { t } = useTranslation('workspace');
    const { isExpanded, toggleExpanded } = useSecondarySidebarStore();

    return (
        <div style={{ position: 'relative', margin: '13px 12px' }}>
            <div
                style={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    cursor: 'pointer',
                    zIndex: 10,
                }}
                onClick={toggleExpanded}
            >
                <Tooltip
                    label={
                        isExpanded
                            ? t('common:action.collapse')
                            : t('common:action.expand')
                    }
                    withArrow
                >
                    <IconLayoutSidebar size={14} color="#868E96" />
                </Tooltip>
            </div>
            <Button
                variant="subtle"
                w="100%"
                styles={{
                    root: {
                        backgroundColor: '#868E961A',
                        position: 'relative',
                    },
                }}
                radius="md"
                size="xs"
                c="dimmed"
                h={isExpanded ? '126px' : '64px'}
                onClick={onCreateWorkspace}
            >
                {isExpanded ? (
                    <Stack gap={8} align="center">
                        <Text size="xs" fw={600}>
                            {t('component.add_button.create')}
                        </Text>
                        <Text
                            size="10px"
                            c="dimmed"
                            ta="center"
                            dangerouslySetInnerHTML={{
                                __html: t('component.add_button.description'),
                            }}
                        />
                    </Stack>
                ) : (
                    <Tooltip
                        label={t('component.add_button.create')}
                        position="bottom"
                        withArrow
                    >
                        <IconPlus
                            style={{
                                position: 'absolute',
                                top: '65%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                            }}
                            size={16}
                            color="#868E96"
                        />
                    </Tooltip>
                )}
            </Button>
        </div>
    );
};

export default WorkspaceAddButton;
